<div class="uk-badge tw-py-2 tw-px-4 tw-rounded tw-inline-flex tw-items-center" [ngClass]="[styleIndicator.class]">
    <span class="tw-uppercase tw-text-base">{{ userRecurringPayment.localState.name }}</span>
</div>
